import { createScheduleModel, type ScheduleModel } from './scheduleModel';
import { authService } from '@/auth/auth.service';
import { createContext, useContext, useLayoutEffect, useMemo, type ReactNode } from 'react';

const ScheduleContext = createContext<ScheduleModel | undefined>(undefined);
export function ScheduleModelProvider({ children }: { children: ReactNode }) {
    const identity = authService.loginState.useStore((state) =>
        state.isLoggedIn === true
            ? JSON.stringify([state.tokenDetails?.iss ?? '', state.tokenDetails?.sub ?? state.tokenDetails?.unique_name ?? ''])
            : 'anonymous',
    );
    const owner = useMemo(() => ({ identity, model: createScheduleModel() }), [identity]);
    useLayoutEffect(() => {
        owner.model.setActive(true);
        return () => owner.model.setActive(false);
    }, [owner]);
    return <ScheduleContext.Provider value={owner.model}>{children}</ScheduleContext.Provider>;
}
export function useScheduleModel() {
    const model = useContext(ScheduleContext);
    if (!model) throw new Error('ScheduleModelProvider is required');
    return model;
}
